import { Column, Row, Txt } from "@stenajs-webui/core";
import { stenaExternalLink } from "@stenajs-webui/elements";

import { UK_CUSTOMS_PROCEDURE_HELP_SECTION_ID } from "../common/help/sectionIds";
import { routeCreators } from "../common/routes/AppRoutes";
import {
  type TrackerCategory,
  trackEvent,
} from "../common/tracking/trackerService";
import { BulletList } from "./bullet-list/BulletList";
import { HelpPopover } from "./HelpPopover";
import { SecondaryButtonLink } from "./Link";
import { ProcedureTag } from "./ProcedureTag";

interface UKCustomsHelpPopoverProps {
  trackerCategory: TrackerCategory;
}

export function UKCustomsHelpPopover({
  trackerCategory,
}: UKCustomsHelpPopoverProps) {
  return (
    <Row flex={1} alignItems={"start"}>
      <HelpPopover
        tabIndex={0}
        headerText={"UK customs procedures"}
        descriptionText={
          "The UK customs procedure determines how your goods are processed at the UK border and which documents are required."
        }
      >
        <Column gap={3}>
          <BulletList>
            <li>
              <Row gap alignItems={"center"}>
                <ProcedureTag label={"TX"} />
                <Txt>UK import declaration or empty unit.</Txt>
              </Row>
            </li>
            <li>
              <Row gap alignItems={"center"}>
                <ProcedureTag label={"PL"} />
                <Txt>Pre-lodgement or empty unit.</Txt>
              </Row>
            </li>
            <li>
              <Row gap alignItems={"center"}>
                <ProcedureTag label={"EX"} />
                <Txt>Transit, ATA carnet, or oral declaration.</Txt>
              </Row>
            </li>
            <li>
              <Row gap alignItems={"center"}>
                <ProcedureTag label={"T1"} />
                <Txt>With office of destination in Harwich or Immingham.</Txt>
              </Row>
            </li>
          </BulletList>
          <SecondaryButtonLink
            target={"_blank"}
            to={{
              pathname: routeCreators.help(),
              hash: UK_CUSTOMS_PROCEDURE_HELP_SECTION_ID,
            }}
            leftIcon={stenaExternalLink}
            label={"Read more"}
            onClick={() => {
              trackEvent({
                category: trackerCategory,
                action: "Press read more (UK customs procedure)",
              });
            }}
          />
        </Column>
      </HelpPopover>
    </Row>
  );
}
